import { ApiMetaDataDTO, ErrorDTO } from 'declarations'
import { useMutation } from '@tanstack/react-query'
import { client } from 'services/helpers/apiConfig'
import { toast } from 'react-toastify'

export type ParamsDTO = {
  uuid: string
  rating: number
}

type ApiResponseDTO = {
  code: number
  data: any
  api_metadata: ApiMetaDataDTO
  message?: string
}

export const useRfqQuoteRatingUpdateMutation = () =>
  useMutation<any, ErrorDTO, ParamsDTO>({
    mutationFn: async (params: ParamsDTO) => {
      try {
        const res = await client.put(
          `/rfq/quote/rating/${params.rating}/${params.uuid}`
        )

        return res.data.data
      } catch (err) {
        toast.error(err.response.data.message)
        throw err.response.data
      }
    },
  })
